
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ManageColumnsMenu extends Vue {
  @Prop({ default: () => [] }) readonly visibleColumns!: string[];
  @Prop({ required: true }) readonly columns!: Array<{ id: string; label: string }>;

  // Must start empty, not `[...this.visibleColumns]` — vue-class-component
  // constructs a throwaway instance to collect field initializers into
  // data(), and props aren't bound yet on that instance, so reading
  // `this.visibleColumns` here throws "not iterable". The immediate watcher
  // below populates it once props are actually attached.
  private staged: string[] = [];

  public toggle(id: string) {
    const idx = this.staged.indexOf(id);
    if (idx === -1) {
      this.staged.push(id);
    } else {
      this.staged.splice(idx, 1);
    }
  }

  public apply() {
    // Emit a copy — consumers store this array (e.g. as their visibleColumns
    // state), and staged keeps mutating in place on every later toggle().
    this.$emit('apply', [...this.staged]);
  }

  @Watch('visibleColumns', { immediate: true })
  private onVisibleColumnsChange(next: string[]) {
    this.staged = [...next];
  }
}
